import { render, staticRenderFns } from "./PreApproved.vue?vue&type=template&id=db423478"
import script from "./PreApproved.vue?vue&type=script&lang=js"
export * from "./PreApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports